<script>
import { CustomForm } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.ForeignKey({
              label: 'Formularz',
              modelPath: [this, 'form', 'form'],
              labelField: 'name_pl',
              clearable: true,
              required: true,
              service: CustomForm
            })
          ]
        }
      ]
    }
  }
}
</script>
